module.exports = __webpack_public_path__ + "img/icn_arrow_back_mobile.050b85c5.svg";